<template>
    <address translate="no">
        <span class="address-line1">{{ entity.street_number }} {{ entity.route }}</span
        ><br />
        <span v-if="entity.suite" class="address-line2">{{ /^[\d\s]+$/.test(entity.suite) ? `#${entity.suite}` : entity.suite }}</span>
        <br v-if="entity.suite" />
        <span class="locality">{{ entity.locality }}</span>
        <template v-if="entity.locality && entity.administrative_area_level_1">,</template>
        <span class="administrative-area">{{ entity.administrative_area_level_1 }}</span>
        <span class="postal-code">{{ entity.postal_code }}</span
        ><br v-if="country" />
        <span v-if="country" class="country">{{ entity.country ? entity.country : entity.country_code }}</span>
    </address>
</template>

<script>
    export default {
        name: 'Address',
        components: {},
        mixins: [],
        props: {
            entity: {
                required: true,
                type: Object,
            },
            country: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {};
        },
        methods: {},
    };
</script>
